import React from "react";
import { useRemoteComponent } from "@bookingcom/remote-component";
import Container from "../elements/Container/index.js";
import Frame from "../elements/Frame/index.js";
import useUserAgent from "../../hooks/useUserAgent.js";
const renderComponent = (Component, isMobile) => {
    return isMobile ? (React.createElement(Frame, { attributes: { style: { width: "100%" } }, p: 4, mt: 2, mb: 2 },
        React.createElement(Component, null))) : (React.createElement(Container, { pt: 6 },
        React.createElement(Component, null)));
};
const GeniusSignInBanner = () => {
    const { isMobile } = useUserAgent();
    const { Component } = useRemoteComponent({
        project: "web-shell",
        service: "header-mfe",
        path: "/FlightsGeniusSignInBanner",
        type: "capla"
    });
    return renderComponent(Component, isMobile);
};
export default GeniusSignInBanner;
